 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"89c7555400aefec281f8ee5bdf2429c5ba354a47","3":"5e6c3d8176e14134ef8ee0f3ae83495bf9ed36dd","4":"67ffa4e1c2b4198f8fc51f89e26a4207a04107a3","5":"a4c92b5b","6":"c646295df5086c12f743ae21316713097c53aa5c","7":"c660a5cc2c6f1fbf25d17e3f1a40b60f65265758","8":"e96041627553ba1a1b34cd74ad888b024eaafe1a","11":"component---src-pages-blog-restaurant-barcode-qr-code-menu-js","12":"component---src-pages-contact-js","13":"component---src-pages-contact-thank-you-js","14":"component---src-pages-index-js","15":"component---src-pages-joined-js","16":"component---src-pages-pricing-components-pricing-js","17":"component---src-pages-pricing-index-js","18":"component---src-pages-qr-menu-1-js","19":"component---src-pages-qr-menu-components-intro-js","20":"component---src-pages-qr-menu-components-optional-js","21":"component---src-pages-qr-menu-components-other-services-js","22":"component---src-pages-qr-menu-components-screenshots-js","23":"component---src-pages-qr-menu-components-why-js","24":"component---src-pages-qr-menu-index-js","25":"component---src-pages-qr-ordering-components-features-js","26":"component---src-pages-qr-ordering-components-foodstagram-js","27":"component---src-pages-qr-ordering-components-how-it-works-js","28":"component---src-pages-qr-ordering-components-intro-js","29":"component---src-pages-qr-ordering-components-loyalty-js","30":"component---src-pages-qr-ordering-components-outro-js","31":"component---src-pages-qr-ordering-components-payments-js","32":"component---src-pages-qr-ordering-components-why-js","33":"component---src-pages-qr-ordering-index-js","34":"component---src-pages-restaurant-apps-components-features-js","35":"component---src-pages-restaurant-apps-components-how-it-works-js","36":"component---src-pages-restaurant-apps-components-intro-js","37":"component---src-pages-restaurant-apps-components-kitchen-app-section-js","38":"component---src-pages-restaurant-apps-components-other-services-js","39":"component---src-pages-restaurant-apps-components-waiter-app-section-js","40":"component---src-pages-restaurant-apps-components-why-js","41":"component---src-pages-restaurant-apps-index-js","42":"component---src-pages-ru-qr-menu-js","43":"component---src-pages-start-js"}[chunkId]||chunkId) + "-" + {"0":"bc00cc84eed442ce041c","1":"e9d24b1846c7d6eb9685","2":"6ac32c14960894f3d613","3":"13fb0f1fa112974cef35","4":"0bf7141a1ff95c74ae2e","5":"b4abcb6a63e8c69c8431","6":"27a7bbb3aede5679360e","7":"8c2fce1963cba419818e","8":"f2fbf34ab48b2059c7a4","11":"7b684e133d7175965b62","12":"fbd67145a14db08b64dc","13":"5238f3617a9aa353ab86","14":"8ff00994ad781bc810b1","15":"817235ce295d8c99315b","16":"65aa2429bac2bb886e51","17":"e5c81ead74061b75e108","18":"0b73ee51b24fd7c373d6","19":"1c370c56e5b19382c3d0","20":"525c83e8ca11cef28731","21":"da87ac846640ed371a6c","22":"b2f98d1d0f45a6358d6a","23":"6c2159036b4a1a2a7d55","24":"2f993398fd8e697d0800","25":"05d239a87594ed1de764","26":"ee73400ed112f1f18cad","27":"a5eecc0f4b4fc1620230","28":"5166723b8b1cbfdf10bf","29":"6029e85bc4491b8bff9c","30":"43aa6fd39eb58953f551","31":"66641be9926361a13cb9","32":"e7e2508d26bbb09cd8f3","33":"a89340e83af70b4294ce","34":"83f66288a2cf92f6bfc7","35":"2c93e80f230ae0bfdfb5","36":"41d8478d5b0e41060942","37":"cdd14a4dea5c498ae62d","38":"25288f9de2e52493cbf2","39":"3ecbd6d2a1d331ca6c22","40":"562666afeffcf101f1d7","41":"2e4fb9c0d610d94fecc0","42":"deacb4affc1a72dbe5bb","43":"968331191f4afc92c3e5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"89c7555400aefec281f8ee5bdf2429c5ba354a47","3":"5e6c3d8176e14134ef8ee0f3ae83495bf9ed36dd","4":"67ffa4e1c2b4198f8fc51f89e26a4207a04107a3","5":"a4c92b5b","6":"c646295df5086c12f743ae21316713097c53aa5c","7":"c660a5cc2c6f1fbf25d17e3f1a40b60f65265758","8":"e96041627553ba1a1b34cd74ad888b024eaafe1a","11":"component---src-pages-blog-restaurant-barcode-qr-code-menu-js","12":"component---src-pages-contact-js","13":"component---src-pages-contact-thank-you-js","14":"component---src-pages-index-js","15":"component---src-pages-joined-js","16":"component---src-pages-pricing-components-pricing-js","17":"component---src-pages-pricing-index-js","18":"component---src-pages-qr-menu-1-js","19":"component---src-pages-qr-menu-components-intro-js","20":"component---src-pages-qr-menu-components-optional-js","21":"component---src-pages-qr-menu-components-other-services-js","22":"component---src-pages-qr-menu-components-screenshots-js","23":"component---src-pages-qr-menu-components-why-js","24":"component---src-pages-qr-menu-index-js","25":"component---src-pages-qr-ordering-components-features-js","26":"component---src-pages-qr-ordering-components-foodstagram-js","27":"component---src-pages-qr-ordering-components-how-it-works-js","28":"component---src-pages-qr-ordering-components-intro-js","29":"component---src-pages-qr-ordering-components-loyalty-js","30":"component---src-pages-qr-ordering-components-outro-js","31":"component---src-pages-qr-ordering-components-payments-js","32":"component---src-pages-qr-ordering-components-why-js","33":"component---src-pages-qr-ordering-index-js","34":"component---src-pages-restaurant-apps-components-features-js","35":"component---src-pages-restaurant-apps-components-how-it-works-js","36":"component---src-pages-restaurant-apps-components-intro-js","37":"component---src-pages-restaurant-apps-components-kitchen-app-section-js","38":"component---src-pages-restaurant-apps-components-other-services-js","39":"component---src-pages-restaurant-apps-components-waiter-app-section-js","40":"component---src-pages-restaurant-apps-components-why-js","41":"component---src-pages-restaurant-apps-index-js","42":"component---src-pages-ru-qr-menu-js","43":"component---src-pages-start-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"c982c6f85429f4a99f02","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
